export default __webpack_public_path__ + "2263e79.png";